
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import includes from 'lodash/includes';
import pull from 'lodash/pull';

import Text from '../../common/client/components/Text';

import { getIsknDateTitle } from '../../reducers/iskn';
import ToolbarCommandButton from './ToolbarCommandButton';

const classNames = mergeStyleSets({
    item: {
        padding: 4
    }
});

const IsknDataCheckboxItem = ({isknDate, checked, onChange}) => {

    const iskn = useSelector(state => state.iskn);

    const handleChange = (e, value) => {
        if (onChange) {
            onChange(e, value, isknDate);
        }
    }

    return (
        <div className={classNames.item}>
            <Checkbox
                label={getIsknDateTitle(iskn, isknDate)}
                checked={checked}
                onChange={handleChange}
            />
        </div>
    );
}

const IsknDataCheckbox = ({isknDatesForAnalyze, isknDatesChecked, onChange}) => {

    const doChange = (values) => {
        if (onChange) {
            onChange(values);
        }
    }

    const handleClickAll = () => {
        doChange([...isknDatesForAnalyze]);
    }

    const handleClickNo = () => {
        doChange([]);
    }

    const handleChangeIsknDate = (e, checked, isknDate) => {
        if (checked) {
            isknDatesChecked.push(isknDate);
        } else {
            pull(isknDatesChecked, isknDate);
        }
        doChange(isknDatesChecked);
    }

    return (
        <Stack>
            <Text bold>Vybrané datové sady ISKN pro analýzu</Text>
            <Stack horizontal wrap>
                {isknDatesForAnalyze.map(item => {
                    return (
                        <IsknDataCheckboxItem
                            key={item}
                            isknDate={item}
                            checked={includes(isknDatesChecked, item)}
                            onChange={handleChangeIsknDate}
                        />
                    );
                })}
            </Stack>
            <Stack>
                <ToolbarCommandButton items={[
                    {
                        text: 'Vybrat vše',
                        title: 'Vybrat všechny datové sady ISKN',
                        onClick: handleClickAll
                    }, {
                        text: 'Odvybrat vše',
                        title: 'Odvybrat všechny datové sady ISKN',
                        onClick: handleClickNo
                    }
                ]}/>
            </Stack>
        </Stack>
    );
}

export default IsknDataCheckbox;
